export default __webpack_public_path__ + "static/11-4101cc798dfcc451532f7b8f431308f8.jpg";